export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100% - 10px)',
        padding: "0px 15px 10px 15px",
        marginBottom: "10px"
    },
    cardContainer: {
        backgroundColor: "#FFFFFF",
        borderRadius: "20px",
        height: "100%",
        overflowY: "auto",
        padding: '20px 20px 0px 20px'

    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    },
    mainHeadingText: {
        fontSize: theme.typography.h2,
        fontWeight: 600,
        color: 'black'
    },
    linkText: {
        fontSize: theme.typography.h2,
        fontWeight: 400,
        color: 'black'
    },
    uploadBtn: {
        backgroundColor: '#0B51C5',
        color: '#FFFFFF',
        borderRadius: '20px',
        width: '150px',
        height: '40px'
    },
    btnText: {
        fontSize: "14px",
        fontWeight: 600,
        textTransform: 'none'
    }
})